import React, {useState} from 'react';
import './Projects.scss';
import GitHubIcon from '@material-ui/icons/GitHub';
import YouTubeIcon from '@material-ui/icons/YouTube';
import {projects} from './allProjects';
import Modal from 'react-modal';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Skeleton from '@material-ui/lab/Skeleton';

function Projects() {

    const [projectState, setProjectState] = useState(projects);
    const [modalIsOpen,setIsOpen] = useState(false);
    const [yt, setYt] = useState('');

    function closeModal(){
        setIsOpen(false);
    }

    return (
        <div className="projects">
             <div className="searchinput-container">
                <input placeholder="Search" type="text" onChange={(e) => {
                    setProjectState(
                        projects.filter((each) => {
                            return each.name.toLowerCase().match(e.target.value.toLowerCase());
                          })
                    )
                }}/>
            </div>
            <div className="cards-container">
            {
                projectState.map((each, index) => (
                <div className="card" key={index}>
                    {
                        each ? (
                            <div className="card-picture">
                                <img src={each.pic} alt={each.name}/>
                            </div>
                        ) : (
                            <Skeleton variant="rect" width={'100%'} height={200} />
                        )
                    }
                    
                    <div className="card-section-head">
                        <h2>{each.name}</h2>
                        <h5>({each.date})</h5>
                    </div>
                    <div className="card-section-desc">
                        <h4>{each.description}</h4>
                    </div>
                    <div className="card-section-btn">
                        <button onClick={() => {
                            window.open(each.github, '_blank')
                        }}><GitHubIcon />View Code</button>
                        {
                            each.youtube ? (
                        <button onClick={() => {
                            setYt(each.youtube);
                            setIsOpen(true);
                        }}><YouTubeIcon />Youtube</button>
                            ) : null
                        }
                        
                    </div>
                </div>

                ))
            }             
            </div>



            <Modal
            className="modal"
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            style={{
                overlay: {
                    background: 'rgba(27, 27, 27, 0.8)'
                }
            }}
            >
            <div className="closeicon-containertab">
                <div></div>
                <div onClick={() => {
                    setIsOpen(false)
                }} className="closeicon-container">
                    <HighlightOffIcon />
                </div>
            </div>
            <div className="modal-space">
                <iframe src={yt} title="ytube" />
            </div>
            
        </Modal>






        </div>
    )
}

export default Projects;
